<template>
  <div class="auth-page">
    <UcariHeader />
    <main class="system-page"><section class="system-card">
      <span class="system-card__icon system-card__icon--success" uk-icon="icon: check; ratio: 1.5"></span>
      <span class="eyebrow">All set</span>
      <h1>Password updated</h1>
      <p>Your password was successfully changed. You can now sign in with your new credentials.</p>
      <router-link to="/login" class="uk-button uk-button-primary">Sign in</router-link>
    </section></main>
    <RetailerFooter />
  </div>
</template>

<script>
import UcariHeader from './components/UcariHeader.vue'; 
import RetailerFooter from './components/RetailerFooter.vue'; 

export default {
  name: 'RequestPasswordReset',
  created() {
    document.title = 'Password Reset Successful | UCARI';
  },
  components: {
    UcariHeader,  
    RetailerFooter
  }
}
</script>
